import React, { FC } from 'react';

import Slider, { SliderProps } from 'rc-slider';

import { SliderValue } from '../../../../utils';

import './RangeSlider.scoped.scss';

export type RangeSliderProps = {
  handleChange: (value: SliderValue) => void;
};

const RangeSlider: FC<SliderProps & RangeSliderProps> = ({ handleChange, ...props }) => {
  const onChange = (value: number[] | number): void => {
    if (typeof value === 'number') {
      handleChange({ min: value, max: value });
      return;
    }

    const [first, second] = value;
    handleChange({ min: first, max: second });
  };

  return (
    <Slider
      {...props}
      range
      styles={{
        rail: { backgroundColor: '#F2F2F2' },
        track: { backgroundColor: '#00703E' },
        handle: { backgroundColor: '#e1eee4', borderColor: '#e1eee4', opacity: 1 },
      }}
      onChange={onChange}
    />
  );
};

export default RangeSlider;
